import _ from 'lodash';
import Noty from 'noty';

export const isRequestSuccess = (response) => {
  if (!(response instanceof Object)) return false;
  return response.status === 200;
};

export const getResponseData = (response) => {
  if (!isRequestSuccess(response)) return null;
  return _.get(response, 'data');
};

export const getResponseError = (response) => _.get(response, 'data.error');

export const axiosGetData = (response) => {
  if (!isRequestSuccess(response)) {
    throw new Error(getResponseError(response));
  }
  return getResponseData(response);
};

export const notifyError = (message) => {
  new Noty({
    text: message,
    type: 'error',
    layout: 'topCenter',
    progressBar: false,
    theme: 'bootstrap-v4',
    timeout: 5000,
  }).show();
};
